import { render, staticRenderFns } from "./Concursos.vue?vue&type=template&id=d7f717ae&scoped=true"
import script from "./Concursos.vue?vue&type=script&lang=js"
export * from "./Concursos.vue?vue&type=script&lang=js"
import style0 from "./Concursos.vue?vue&type=style&index=0&id=d7f717ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f717ae",
  null
  
)

export default component.exports